<template>
  <footer class="footer">
    <div class="footer-top">
      <!-- Left -->
      <div class="footer-left">
        <p class="description">
          {{ $t("message.hero_title1") }}
        </p>

        <nav class="links">
          <a href="#whyChooseUs">{{ $t("message.footer_menu2") }}</a>
          <a href="#howItWorks">{{ $t("message.footer_menu3") }}</a>
        </nav>
      </div>

      <!-- Right -->
      <div class="footer-right">
        <div class="store-buttons">
          <img
            src="@/assets/icons/app-store.svg"
            alt="Download on the App Store"
          />
          <img
            src="@/assets/icons/google-play.svg"
            alt="Get it on Google Play"
          />
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="footer-bottom">
      <p>© {{ $t("message.all_rights_reserved") }}</p>

      <div class="socials">
        <a href="https://www.linkedin.com/company/farrther/" target="_blank"><img src="@/assets/icons/linkedin.svg" alt="LinkedIn" /></a>
        <a href="https://www.facebook.com/people/Farrther/61583001917776/" target="_blank"><img src="@/assets/icons/facebook.svg" alt="Facebook" /></a>
        <a href="https://www.instagram.com/farrther_travel" target="_blank"><img src="@/assets/icons/instagram.svg" alt="Instagram" /></a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: #183a34;
  color: #cfd8d6;
  padding: 60px 80px 30px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.footer-left {
  max-width: 520px;
}

.description {
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.6;
}

.links {
  display: flex;
  gap: 28px;
}

.links a {
  color: #cfd8d6;
  text-decoration: none;
  font-size: 15px;
  opacity: 0.85;
}

.links a:hover {
  opacity: 1;
}

.footer-right {
  display: flex;
  align-items: center;
}

.store-buttons {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.store-buttons img {
  height: 46px;
  cursor: pointer;
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 40px 0 24px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.socials {
  display: flex;
  gap: 18px;
}

.socials img {
  width: 22px;
  height: 22px;
  opacity: 0.8;
}

.socials img:hover {
  opacity: 1;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .footer {
    padding: 50px 24px 30px;
  }

  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}
</style>
